module.exports = __webpack_public_path__ + "/images/ico-color-gift.5c1a777.svg";